import axios from 'axios';
import { Device } from '../interfaces/api/device';

export async function getDevices(): Promise<Device[]> {
	try {
		const response = await axios.get<Device[]>('api/devices/');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getDevice(id: number): Promise<Device> {
	try {
		const response = await axios.get<Device>(`api/devices/${id}/`);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
